import * as Types from './workstationActionTypes.js'

const initialState = {
    workstations: [],
    zones: [],
    machineParameters: [],
    activeWorkstations: [],
    selectedWorkstation: 0,
    selectedZone: null,
    workstationNotificationsDrawerOpen: false,
    noSelectedWorkstation: false,
    noSelectedRecyclingWorkstation: true,
    operators: [],
    selectedCarpentryWorkstationId: 0,
    selectedRecyclingWorkstationId: 0,
};

export default function workstation(state = initialState, action) {
    switch (action.type) {
        case Types.SET_WORKSTATIONS:
            if (state.workstations !== action.workstations) {
                return Object.assign({}, state, { workstations: action.workstations });
            }
            return state;
        case Types.SET_ZONES:
            if (state.zones !== action.zones) {
                return Object.assign({}, state, { zones: action.zones });
            }
            return state;
        case Types.SET_MACHINEPARAMETERS:
            if (state.machineParameters !== action.parameters) {
                return Object.assign({}, state, { machineParameters: action.parameters });
            }
            return state;
        case Types.SET_ACTIVEWORKSTATIONS:
            if (state.activeWorkstations !== action.activeWorkstations) {
                return Object.assign({}, state, { activeWorkstations: action.activeWorkstations });
            }
            return state;
        case Types.SET_SELECTEDWORKSTATION:
            if (state.selectedWorkstation !== action.selectedWorkstation) {
                return Object.assign({}, state, { selectedWorkstation: action.selectedWorkstation });
            }
            return state;
        case Types.SET_SELECTEDZONE:
            if (state.selectedZone !== action.selectedZone) {
                return Object.assign({}, state, { selectedZone: action.selectedZone });
            }
            return state;
        case Types.SET_NOSELECTEDWORKSTATION:
            if (state.noSelectedWorkstation !== action.noSelectedWorkstation) {
                return Object.assign({}, state, { noSelectedWorkstation: action.noSelectedWorkstation });
            }
            return state;
        case Types.SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN:
            if (state.workstationNotificationsDrawerOpen !== action.workstationNotificationsDrawerOpen) {
                return Object.assign({}, state, { workstationNotificationsDrawerOpen: action.workstationNotificationsDrawerOpen });
            }
            return state;
        case Types.SET_OPERATORS:
            if (state.operators !== action.operators) {
                return Object.assign({}, state, { operators: action.operators });
            }
            return state;   
        case Types.SET_CARPENTRYWORKSTATION:
            if (state.selectedCarpentryWorkstationId !== action.selectedCarpentryWorkstationId) {
                return Object.assign({}, state, { selectedCarpentryWorkstationId: action.selectedCarpentryWorkstationId });
            }
            return state;   
        case Types.SET_ACTIVERECYCLINGWORKSTATIONS:
            if (state.activeRecyclingWorkstations !== action.activeRecyclingWorkstations) {
                return Object.assign({}, state, { activeRecyclingWorkstations: action.activeRecyclingWorkstations });
            }
            return state;
        case Types.SET_NOSELECTEDRECYCLINGWORKSTATION:
            if (state.noSelectedRecyclingWorkstation !== action.noSelectedRecyclingWorkstation) {
                return Object.assign({}, state, { noSelectedRecyclingWorkstation: action.noSelectedRecyclingWorkstation });
            }
            return state;
        case Types.SET_SELECTEDRECYCLINGWORKSTATION:
            if (state.selectedRecyclingWorkstationId !== action.selectedRecyclingWorkstationId) {
                return Object.assign({}, state, { selectedRecyclingWorkstationId: action.selectedRecyclingWorkstationId });
            }
            return state;
        default:
            return state;
    }
}